import React from "react";

import { Svg } from "./partials/Svg";
import { Group } from "./partials/Group";
import { LineChart } from "./partials/LineChart";
import { ChartProps } from "./Chart";

import { chartColors } from "../../config/colors";
import { margin } from "../../config/spacing";

import carbondioxideData from "./data/carbondioxide.json";
import temperatureData from "./data/temperature.json";

export const CarbonTemp: React.FC<ChartProps> = ({
  id,
  width = 250,
  height = 400,
  isAnimated = true,
}) => {
  return (
    <Svg id={id} width={width} height={height}>
      <Group transform={`translate(${margin.left}, ${margin.top})`}>
        <Group transform="translate(0, 0)">
          <LineChart
            id="co2"
            data={carbondioxideData}
            title={"Kohlenstoffdioxid"}
            description={"CO₂ in der Atmosphäre"}
            unit={"ppm"}
            source={"NOAA"}
            sourceLink={"https://gml.noaa.gov/ccgg/trends/mlo.html"}
            infoLink={"https://www.ardalpha.de/klimazahlen-kohlenstoffdioxid-100.html"}
            color={chartColors.blue}
            isAnimated={isAnimated}
          />
        </Group>
        <Group transform={`translate(0, ${height / 2})`}>
          <LineChart
            id="temp"
            data={temperatureData}
            title={"Temperatur"}
            description={"Globale Oberflächentemperatur"}
            unit={"°C"}
            source={"NASA"}
            sourceLink={"https://data.giss.nasa.gov/gistemp/"}
            infoLink={"https://www.ardalpha.de/klimazahlen-temperatur-100.html"}
            color={chartColors.darkSalmon}
            isAnimated={isAnimated}
          />
        </Group>
      </Group>
    </Svg>
  );
};
